import React, { FC } from 'react'
import { Box, Theme } from '@mui/material'
import {
  OverridableComponent
} from '@mui/material/OverridableComponent'
import {
  SvgIconTypeMap
} from '@mui/material/SvgIcon'
import Snackbar from '@mui/material/Snackbar'
import SnackbarContent from '@mui/material/SnackbarContent'
import IconButton from '@mui/material/IconButton'

import CloseIcon from '@mui/icons-material/Close'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WarningIcon from '@mui/icons-material/Warning'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'

import {
  SnackbarStateType,
} from '@kaidam/fc-shared/src/types/frontend/store'

import {
  IVoidCallback,
} from '@kaidam/fc-shared/src/types/utils'

import { green, amber } from '@mui/material/colors'

const variantIcon: {
  [name: string]: any,
} = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}

const getBackgroundColor = (type: SnackbarStateType, theme: Theme) => {
  switch (type) {
    case 'success':
      return green[600]
    case 'warning':
      return amber[700]
    case 'error':
      return theme.palette.error.dark
    case 'info':
      return theme.palette.primary.dark
    default:
      return theme.palette.primary.dark
  }
}

const SnackbarRender: FC<React.PropsWithChildren<{
  open: boolean,
  text: string,
  type: SnackbarStateType,
  onClose: IVoidCallback,
}>> = ({
  open,
  text,
  type,
  onClose,
}) => {
  const Icon = variantIcon[type]

  return (
    <Box>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={3000}
        disableWindowBlurListener={true}
        onClose={onClose}
      >
        <SnackbarContent
          sx={(theme) => ({
            backgroundColor: getBackgroundColor(type, theme),
            margin: theme.spacing(1),
          })}
          aria-describedby="client-snackbar"
          message={
            <Box
              component="span"
              id="client-snackbar"
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {Icon && (
                <Icon
                  sx={{
                    fontSize: 20,
                    opacity: 0.9,
                    marginRight: 1,
                  }}
                />
              )}
              {text}
            </Box>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={onClose}
              size="large"
              sx={(theme) => ({
                padding: theme.spacing(0.5),
              })}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </Box>
  )
}

export default SnackbarRender